import { isPartnerApp } from "@/Utils";
import { useFeatureFlag } from "./useFeature";

const useNewQuoteBlockDesign = (isQuoteBlockRevamped: boolean): boolean => {
	const isQuoteBlockRevampEnabled = useFeatureFlag("quote_block_revamp");
	return isQuoteBlockRevampEnabled && isQuoteBlockRevamped && isPartnerApp();
};
export default useNewQuoteBlockDesign;
